const Register = () => {
    return (
        <div>
            Register Screen
        </div>
    )
}

export default Register